import puppeteer from 'puppeteer';
import envInfo from '../../envInfo'
import log from 'electron-log';

const axios = require('axios');
const path = require('path');
let browser, page, browserNum = 0;
let onlineNumbers = null, keyWords = [];
let timer, sendData = {};
let keywordsIsError = false, onlineNumIsError = false;
let logData = {
    'name': 'barrages-logs'
}

const hostConfig = {
    dev: 'http://172.16.22.206:5999',
}

let url = `${envInfo.apiUrl}/coreService/v1/trigger/put`
let logUrl = `${envInfo.apiUrl}/coreService/v1/log/add`

let exPath;
exPath = process.env.NODE_ENV == 'development' ? path.resolve(__dirname, '../../public/.cache/puppeteer/chrome/win64-1095492/chrome-win/chrome.exe') : path.resolve(__dirname, '../renderer/.cache/puppeteer/chrome/win64-1095492/chrome-win/chrome.exe')

export default async function barrages(arg: any) {
    logData.mobile = arg.accountInfoByBarrage.mobile;

    if (arg.isCloseBrowser) {
      log.info("关闭游览器", arg)

      clearInterval(timer);
        browser && browser.close();
        browserNum = 0;
        logData.content = 'isCloseBrowser is true, Close the browser normally';
        sendLogs(logData, arg.headers)
        return
    }
    log.info("barrages", browserNum)
    if (browserNum === 0) {
        try {
            browser = await puppeteer.launch({
                executablePath: exPath,
                headless: false,
                devtools: false,
                args: ['--start-maximized'],
                defaultViewport: null
            });
        } catch (error) {
            logData.content = 'puppeteer.launch Function:' + error;
            sendLogs(logData, arg.headers)
        }

        browser && browserNum++;

        try {
            page = await browser.newPage();
        } catch (error) {
            logData.content = 'browser.newPage Function:' + error;
            sendLogs(logData, arg.headers)
        }

        await retry(() => page.goto(arg.url), 3, arg);
    }

    //监听页面发生error
    page.on('error', (error) => {
        log.error('page error:', error)
        clearInterval(timer);
        browser && browser.close();
        browserNum = 0;
        logData.content = 'page.on error Function:' + error;
        sendLogs(logData, arg.headers)
    })

    //监听页面关闭
    page.once('close', () => {
        log.info('page is closed')
        clearInterval(timer);
        browser && browser.close();
        browserNum = 0;
        logData.content = 'page.once close Function';
        sendLogs(logData, arg.headers)
    });
    if (timer) clearInterval(timer);
    timer = setInterval(async () => {
        if (arg.keywords) {
            try {
                keywordsIsError = false;
                keyWords = await page.$$eval(arg.keywords, el => el.map(el => el.innerHTML))
                log.info('91-查找到的弹幕:' , keyWords,)
            } catch (error) {
                keywordsIsError = true;
                log.error('95-查弹幕Error:' , error)

            }
        }
        if (arg.onlineNum) {
            try {
                onlineNumIsError = false;
                onlineNumbers = await page.$$eval(arg.onlineNum, el => el.map(el => el.innerHTML))
            } catch (error) {
                onlineNumIsError = true;
                log.error('get onlineNumbers Error:', error)
            }
        }

        //配置了关键字和在线人数
        /*if (arg.keywords && arg.onlineNum) {
            if (keywordsIsError && onlineNumIsError) {
                clearInterval(timer);
                browser && browser.close();
                browserNum = 0;
                logData.content = 'keywordsIsError is true and onlineNumIsError is true';
                sendLogs(logData, arg.headers)
                return
            }
        } else if (arg.keywords) {
            if (keywordsIsError) {
                clearInterval(timer);
                browser && browser.close();
                browserNum = 0;
                logData.content = 'keywordsIsError is true';
                sendLogs(logData, arg.headers)
                return
            }
        } else if (arg.onlineNum) {
            if (onlineNumIsError) {
                clearInterval(timer);
                browser && browser.close();
                browserNum = 0;
                logData.content = 'onlineNumIsError is true';
                sendLogs(logData, arg.headers)
                return
            }
        } else {
            clearInterval(timer);
            browser && browser.close();
            browserNum = 0;
            logData.content = 'keywords and onlineNum not exist';
            sendLogs(logData, arg.headers)
        }*/

        if (arg.keywords || arg.onlineNum) {
            sendData = {
                "roomId": arg.roomId,
                "liveId": arg.liveId,
                "data": []
            }
            arg.keywords ? sendData.data.push({ "type": 1, "data": keyWords }) : void (0);

            if(arg.onlineNum && onlineNumbers && onlineNumbers[0]){
                let num = onlineNumbers && onlineNumbers[0];
                let i = num.indexOf('万');
                if(i > -1){
                    num = num.slice(0, i) + '0000';
                }
                sendData.data.push({ "type": 2, "data": num })
            }

            if ((keyWords && keyWords.length > 0) || (onlineNumbers && onlineNumbers.length > 0)) {
                sendBarrages(sendData, arg.headers)
              log.info("164准备发送请求" , sendData, url, arg.headers)

            }
        }
    }, 3 * 1000)


}

async function sendBarrages(data: any, headers: any) {
    await axios({
        url: url,
        method: 'POST',
        data: data,
        headers: headers
    }).then((res: any) => {
      log.info("179发送请求成功" , data , headers, url)

    }).catch((error: any) => {
      log.error("183发送请求失败" , data , headers, url, error)
    })

}

async function sendLogs(data: any, headers: any) {
    await axios({
        url: logUrl,
        method: 'POST',
        data: data,
        headers: headers
    }).then((res: any) => {
      log.info("194发送请求成功" , data , headers, url)


    }).catch((error: any) => {
      log.info("198发送请求失败" , data , headers, url, error)

    })

}

async function retry(promiseFactory: any, retryCount: any, arg: any) {
    try {
        return await promiseFactory();
    } catch (error) {
        if (retryCount <= 0) {
            log.error('fetch error:', error)
            await browser && browser.close();
            browserNum = 0;
            logData.content = 'retry Function:' + error;
            sendLogs(logData, arg.headers)
            return
        }
        return await retry(promiseFactory, retryCount - 1);
    }
}
